<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Información" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <NuevoReglamentoCirculacion v-if="visibleNuevoReglamentoCirculacion" class="tarjeta" />
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    visibleNuevoReglamentoCirculacion() {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
